import { Link } from "react-router-dom";

export default function AdminPanel() {


  return (
    <div className="max-w-4xl mx-auto mt-10 p-6">
      <h1 className="text-3xl font-bold text-sky-400 mb-6">
        🛠️ Admin-Panel
      </h1>
      <p className="mb-8 text-slate-400">
        Willkommen im Administrationsbereich. Wähle einen Bereich zur
        Verwaltung:
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link
          to="/admin/packlists"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">
            🎒 Packlisten verwalten
          </h2>
          <p className="text-slate-400">
            Templates, Kategorien und Tags zentral bearbeiten.
          </p>
        </Link>
        <Link
          to="/admin/users"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">🧑‍🤝‍🧑 Nutzerübersicht</h2>
          <p className="text-slate-400">
            Übersicht aller registrierten Nutzer – mit Zugriff auf Push-Tokens &
            weitere Einstellungen.
          </p>
        </Link>

        <Link
          to="/admin/faq"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">❓ FAQ verwalten</h2>
          <p className="text-slate-400">
            Einträge erstellen, bearbeiten und veröffentlichen.
          </p>
        </Link>

        {/* Neu: KPIs */}
        <Link to="/admin/kpis" className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors">
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📈 Engagement & KPIs</h2>
          <p className="text-slate-400">Zeitreihen, kumulatives Wachstum & Filter.</p>
        </Link>

        {/* Neu: E-Mail-System */}
        <Link
          to="/admin/emails"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📧 E-Mail-System</h2>
          <p className="text-slate-400">
            Templates, Regeln, Queue & Versandhistorie verwalten.
          </p>
        </Link>

        {/* Platzhalter für spätere Admin-Features */}
        <div className="block bg-[#1e2639] border border-dashed border-[#2a3347] rounded-lg p-6 text-slate-500">
          <h2 className="text-xl font-semibold mb-2">📝 Weitere Bereiche</h2>
          <p>z. B. Blog, Userverwaltung, Statistiken …</p>
        </div>
      </div>
    </div>
  );
}
